import { AfterViewInit, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-simple-progress-bar',
  imports: [],
  templateUrl: './simple-progress-bar.component.html',
  styleUrl: './simple-progress-bar.component.scss',
})
export class SimpleProgressBarComponent implements AfterViewInit {
  enableTransition = false;
  percentage = input.required<number>();

  ngAfterViewInit() {
    // prevent progress bar flash on initial render
    setTimeout(() => (this.enableTransition = true), 0);
  }

  private viewModel = computed(() => {
    return {
      roundedPercentage: Math.round(this.percentage()),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
